import {
  PickerPaper,
  PickerPaperHeader
} from '../../PlanningEntityPicker.styles';

import type { PlanningEntityPickerPaperProps } from './PlanningEntityPickerPaper.types';

/**
 * The dropdown's paper with the type chips above the results, so they only take room while the search is
 * in use. A mouse press on the chips is kept from blurring the search field, which would close the dropdown
 * before the click lands; the list stays open and narrows in place.
 */
const PlanningEntityPickerPaper = ({
  header,
  children,
  ...paperProps
}: PlanningEntityPickerPaperProps) => {
  'use memo';

  return (
    <PickerPaper {...paperProps}>
      <PickerPaperHeader onMouseDown={(event) => event.preventDefault()}>
        {header}
      </PickerPaperHeader>
      {children}
    </PickerPaper>
  );
};

export default PlanningEntityPickerPaper;
